class Ymap {
    constructor() {
      this.init();
    }
    init() {
      console.log('[ Ymap ] init');

      this.jsYmap();
      this.delivMap();
    }

    jsYmap() {
      let map = '#js-map';
      if ($(map).hasClass('map-wrap')) {
        ymaps.ready(init);
        function init() {
          let data = $(map).data();
          let coords = coords = data.coords.split(',') || [55.159843, 61.426125];
          let hint = data.firm_name || 'Карформа',
              address = data.address || '454090, Челябинская область, <br>г. Челябинск, пр. Ленина, 21-А, корп. 1, офис 3',
              phone = data.phone || '+7 351 2778937',
              email = data.email || 'manager@carforma.ru';
          let balloon = `Адрес: <span class="important16">${address}</span><br>`
            + `Email: <a class="contacts__emaillink important16" href="mailto: ${email}">${email}</a><br>`
            + `Телефон: <a class="important16" href="tel: ${phone}">${phone}</a>`;

          var myMap = new ymaps.Map("js-map", {
            behaviors: ['multiTouch'],
            controls: [],
            center: coords,
            zoom: 17
          });
          var myPlacemarkWithContent = new ymaps.Placemark(coords, {
            hintContent: hint,
            balloonContent: balloon
          });

          myMap.behaviors.disable('scrollZoom');
          myMap.controls.add('zoomControl');
          myMap.behaviors.enable('drag');

          myMap.geoObjects.add(myPlacemarkWithContent);
        }
      }
    }

  sdekMap() {
    if ($('#cdek_pickup__ymaps').find('.js-cdek_pickup__item').length != 0) {
      if ($('#cdek_pickup__ymaps').find('ymaps').length == 0) {
      ymaps.ready(init);
      function init() {
        var i = 0;
        var myMap = new ymaps.Map("cdek_pickup__ymaps", {
          behaviors: ['multiTouch'],
          controls: [],
          center: [55.159843, 61.426125],
          zoom: 17
        });

        myMap.behaviors.disable('scrollZoom');
        myMap.controls.add('zoomControl');
        myMap.behaviors.enable('drag');

        var clusterer = new ymaps.Clusterer({
            preset: 'islands#invertedBlueClusterIcons',
            groupByCoordinates: false,
            clusterDisableClickZoom: false,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false
        });
        var myCollection = new ymaps.GeoObjectCollection(null, {
            preset: 'islands#blueIcon'});
        $('#cdek_pickup__ymaps .js-cdek_pickup__item').each(function(){
          let placemark = new ymaps.Placemark([$(this).data('coordy'), $(this).data('coordx')], {
              balloonContentHeader: $(this).data('name'),
              balloonContentBody: "<div class='js-map-cont' data-address='"+$(this).data('address')+"' data-time='"+$(this).data('time')+"' data-phone='"+$(this).data('phone')+"' data-name='"+$(this).data('name')+"' data-code='"+$(this).data('code')+"' data-postalcode='"+$(this).data('postalcode')+"'>Адрес: <span class='important16'>"+$(this).data('address')+"</span><br>Телефон: <span class='important16'>"+$(this).data('phone')+"</span><br>Время работы:<span class='important16'>"+$(this).data('time')+"</span><br><div class='button js-baloon-btn'>Выбрать этот пункт!</div></div>",
            });
            placemark.events.add('balloonopen', function() {
              $('.js-baloon-btn').click(function(){
                var inf = {
                  address: $(this).parents('.js-map-cont').data('address'),
                  phone: $(this).parents('.js-map-cont').data('phone'),
                  code: $(this).parents('.js-map-cont').data('code'),
                  name: $(this).parents('.js-map-cont').data('name'),
                  postalcode: $(this).parents('.js-map-cont').data('postalcode'),
                  time: $(this).parents('.js-map-cont').data('time'),
                };
                $.ajax({
                  method: "POST",
                  url:'/oa/Select_PVZ/',
                  data: inf,
                  dataType:'json'
                }).then((data) => {
                    console.log(data);
                    $('.js-form-order__btn').prop('disabled',false);
					$('.js-form-order__info-pvz').addClass('m--hidden');
                    $('.js-form-order__delivery-method').text('«СДЭК» '+data.pvz.name);
                })
                $(this).text('Пункт выбран');
                if ($(document).width() < 768) {
                  $("body,html").animate({scrollTop: $('.form-order__total').offset().top}, 400);
                }
              })
            })
            clusterer.add(placemark);
        })
        myMap.geoObjects.add(clusterer);
        myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange: true});
      }
    }
    }
  }

  yandexMap() {
    if ($('#yandex__ymaps').find('.js-yandex__item').length != 0) {
      if ($('#yandex__ymaps').find('ymaps').length == 0) {
      ymaps.ready(init);
      function init() {
        var i = 0;
        var myMap = new ymaps.Map("yandex__ymaps", {
          behaviors: ['multiTouch'],
          controls: [],
          center: [55.159843, 61.426125],
          zoom: 17
        });

        myMap.behaviors.disable('scrollZoom');
        myMap.controls.add('zoomControl');
        myMap.behaviors.enable('drag');

        var clusterer = new ymaps.Clusterer({
            preset: 'islands#invertedBlueClusterIcons',
            groupByCoordinates: false,
            clusterDisableClickZoom: false,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false
        });
        var myCollection = new ymaps.GeoObjectCollection(null, {
            preset: 'islands#blueIcon'});
        $('#yandex__ymaps .js-yandex__item').each(function(){
          let placemark = new ymaps.Placemark([$(this).data('coordy'), $(this).data('coordx')], {
              balloonContentHeader: $(this).data('name'),
              balloonContentBody: "<div class='js-map-cont' data-address='"+$(this).data('address')+"' data-time='"+$(this).data('time')+"' data-phone='"+$(this).data('phone')+"' data-name='"+$(this).data('name')+"' data-code='"+$(this).data('code')+"' data-postalcode='"+$(this).data('postalcode')+"'>Адрес: <span class='important16'>"+$(this).data('address')+"</span><br>Телефон: <span class='important16'>"+$(this).data('phone')+"</span><br>Время работы:<span class='important16'>"+$(this).data('time')+"</span><br><div class='button js-baloon-btn'>Выбрать этот пункт!</div></div>",
            });
            placemark.events.add('balloonopen', function() {
              $('.js-baloon-btn').click(function(){
                var inf = {
                  address: $(this).parents('.js-map-cont').data('address'),
                  phone: $(this).parents('.js-map-cont').data('phone'),
                  code: $(this).parents('.js-map-cont').data('code'),
                  name: $(this).parents('.js-map-cont').data('name'),
                  postalcode: $(this).parents('.js-map-cont').data('postalcode'),
                  time: $(this).parents('.js-map-cont').data('time'),
                };
                $.ajax({
                  method: "POST",
                  url:'/oa/Select_PVZ/',
                  data: inf,
                  dataType:'json'
                }).then((data) => {
                    console.log(data);
                    $('.js-form-order__btn').prop('disabled',false);
					$('.js-form-order__info-pvz').addClass('m--hidden');
                    $('.js-form-order__delivery-method').html('Яндекс Доставка. '+data.pvz.name+'<br>'+data.pvz.address);
                })
                $(this).text('Пункт выбран');
                if ($(document).width() < 768) {
                  $("body,html").animate({scrollTop: $('.form-order__total').offset().top}, 400);
                }
              })
            })
            clusterer.add(placemark);
        })
        myMap.geoObjects.add(clusterer);
        myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange: true});
      }
    }
    }
  }

  delivMap() {
    $('.js-accordion-label').click(function(){
      $(this).parent('.trigger').toggleClass('is--active');

      if ($(this).parent('.trigger').find('.delivery-payment-karta .js-__item').length != 0) {

        if ($(this).parent('.trigger').find('.delivery-payment-karta ymaps').length == 0) {

          $(this).parent('.trigger').find('.delivery-payment-karta').css('height','400px');
		  var id = $(this).parent('.trigger').find('.delivery-payment-karta').attr('id');
			console.error(id);
          ymaps.ready(init(id));
          function init(id) {
			
            var i = 0;
            var myMap = new ymaps.Map(id, {
              behaviors: ['multiTouch'],
              controls: [],
              center: [55.159843, 61.426125],
              zoom: 17
            });

            myMap.behaviors.disable('scrollZoom');
            myMap.controls.add('zoomControl');
            myMap.behaviors.enable('drag');

            var clusterer = new ymaps.Clusterer({
              preset: 'islands#invertedBlueClusterIcons',
              groupByCoordinates: false,
              clusterDisableClickZoom: false,
              clusterHideIconOnBalloonOpen: false,
              geoObjectHideIconOnBalloonOpen: false
            });
            var myCollection = new ymaps.GeoObjectCollection(null, {
                preset: 'islands#blueIcon'});
            $('#' + id + ' .js-__item').each(function(){
              let placemark = new ymaps.Placemark([$(this).data('coordy'), $(this).data('coordx')], {
                balloonContentHeader: $(this).data('name'),
                balloonContentBody: "<div class='js-map-cont' data-address='"+$(this).data('address')+"' data-time='"+$(this).data('time')+"' data-phone='"+$(this).data('phone')+"' data-name='"+$(this).data('name')+"' data-code='"+$(this).data('code')+"' data-postalcode='"+$(this).data('postalcode')+"'>Адрес: <span class='important16'>"+$(this).data('address')+"</span><br>Телефон: <span class='important16'>"+$(this).data('phone')+"</span><br>Время работы:<span class='important16'>"+$(this).data('time')+"</span>",
              });
              clusterer.add(placemark);
            })
            myMap.geoObjects.add(clusterer);
            myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange: true});
          }
        }
      }
    });
  }
}

export {
    Ymap
};
